var Pref = Pref || {};

(function (){
  /**
   * すべての都道府県を返却
   */
  Pref.all = function() {
    var defer = $.Deferred();
    $.ajax({
      url: '/service/prefs.json',
      method: 'GET',
      success: defer.resolve,
      error: defer.reject
    });
    return defer.promise();
  }

  /**
   * Get Prefs from StoreId
   */
  Pref.store = function(storeId) {
    return $.ajax({
      url: '/service/prefs.json',
      method: 'GET',
      data: {
        storeId: storeId
      }
    });
  }
})();
